import React, { useState } from 'react';
import './Calculator.css';
import Tilt from 'react-tilt';

const Calculator = () => {
    const [calc, setCalc] = useState('');
    const [result, setResult] = useState('');

    const ops = ['/', '*', '+', '-', '.'];

    const updateCalc = (value) => {
        if ((ops.includes(value) && calc === '') || 
            (ops.includes(value) && ops.includes(calc.slice(-1)))) {
            return;
        }
        setCalc(calc + value);

        if (!ops.includes(value)) {
            setResult(eval(calc + value).toString());
        }
    }

    const calculate = () => {
        setCalc(eval(calc).toString());
    }

    const deleteLast = () => {
        if (calc === '') {
            return;
        }

        const value = calc.slice(0, -1);
        setCalc(value);
    }

    const clearCalc = () => {
        setCalc('');
        setResult('');
    }

    const createDigits = () => {
        const digits = [];
        
        for (let i = 1; i < 10; i++) {
            digits.push(
                <button onClick={() => updateCalc(i.toString())} key={i}>{i}</button>
            )
        }

        return digits;
    }

    return (
        <div className="calculator__wrapper">
            <Tilt className="calculator" options={{ max : 15, speed: 400, }}>
                <div className="display">
                    {result ? <span>({result})</span> : ""} &nbsp; {calc || "0"}
                </div>

                <div className="operators">
                    <button onClick={clearCalc}>C</button>

                    <button onClick={() => updateCalc('/')}>/</button>
                    <button onClick={() => updateCalc('*')}>*</button>
                    <button onClick={() => updateCalc('+')}>+</button>
                    <button onClick={() => updateCalc('-')}>-</button>

                    <button onClick={deleteLast}>DEL</button>
                </div>

                <div className="digits">
                    { createDigits() }
                    <button onClick={() => updateCalc('0')}>0</button>
                    <button onClick={() => updateCalc('.')}>.</button>
                    <button onClick={calculate}>=</button>
                </div>
            </Tilt>
        </div>
    )
}

export default Calculator
